import { render, staticRenderFns } from "./menuItem.vue?vue&type=template&id=603059e2&functional=true&"
import script from "./menuItem.vue?vue&type=script&lang=ts&"
export * from "./menuItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports